export default function Sidebar({ selectedType, form }) {
  return (
    <aside className="h-fit bg-[var(--yp-primary)] text-white rounded-2xl p-6 lg:sticky lg:top-28">
      <div className="text-xs uppercase tracking-widest text-white/70">Your Visit</div>
      <div className="font-serif-display text-lg mt-1">{selectedType?.label || "Select a visit type"}</div>
      <p className="text-sm text-white/70 mt-2">Complete the form and review everything before submitting.</p>

      <SummaryRow label="Contact" value={form.full_name || "Not entered"} />
      <SummaryRow label="Location" value={[form.city, form.state].filter(Boolean).join(", ") || "Not entered"} />
      <SummaryRow label="Preferred Date" value={form.date || "Not selected"} />
      <SummaryRow label="Budget" value={form.budget || "Not selected"} />

      <div className="mt-4 bg-white/10 border border-white/15 rounded-xl p-3 text-xs leading-relaxed">
        <div className="font-semibold mb-1">What happens next?</div>
        We review your request → confirm the visit → assess the site → recommend the solution →
        provide a quotation or project plan where applicable.
      </div>
    </aside>
  );
}

function SummaryRow({ label, value }) {
  return (
    <div className="py-2 border-b border-white/15 last:border-0">
      <div className="text-[10px] uppercase tracking-widest text-white/60">{label}</div>
      <div className="text-sm font-medium">{value}</div>
    </div>
  );
}
